<template>
    <SegnalazioneCommon v-model="properties" />
</template>

<script setup>


import SegnalazioneCommon from "@/reports/components/SegnalazioneCommon";

import { onMounted } from 'vue'

const properties = defineModel()


// eslint-disable-next-line no-unused-vars
const props = defineProps({
  "isNew": {
    type: Boolean,
    default: false
  }
})




onMounted(() => {
  console.log("mounted")
  if (props.isNew) {
    properties.value.label = "Generica"
  }
})

</script>
